// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._y44vkmg5{animation:flickerAnimation 2s infinite}._18m915vq{overflow-y:hidden}\n._18u0utpp{margin-left:var(--ds-space-150,9pt)}\n._1bto1l2s{text-overflow:ellipsis}\n._1reo15vq{overflow-x:hidden}\n._kqswh2mm{position:relative}\n@keyframes flickerAnimation{0%{opacity:1}50%{opacity:.5}to{opacity:1}}", ""]);
// Exports
module.exports = exports;
